/** Pending scroll target when navigating Badges Feed activity → profile /feed. */
let pending: { key: string; fallbackBadgeId: string | null } | null = null;

export const setPendingFeedScroll = (key: string, fallbackBadgeId?: string | null): void => {
  pending = { key, fallbackBadgeId: fallbackBadgeId ?? null };
};

export const getPendingFeedScroll = (): {
  key: string;
  fallbackBadgeId: string | null;
} | null => pending;

export const clearPendingFeedScroll = (): void => {
  pending = null;
};
